import request from '@/utils/request'

/**
 * 获取金币交易记录列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listGoldDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.listGoldDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}